import { Component, OnInit, ViewEncapsulation, NgZone, Input, SimpleChanges } from '@angular/core';
import { Platform, PopoverController } from '@ionic/angular';
import { App } from '@capacitor/app';
import { AppService } from 'src/app/app.service';
import { ActivatedRoute } from '@angular/router';
import { DataResolverService } from 'src/app/resolvers/data-resolver.service';
import { GreenpassService } from 'src/app/services/greenpass/greenpass.service';
import { AreaManagementService } from 'src/app/services/area-management/area-management.service';
import { ModalController } from '@ionic/angular';
import { RapidtourService } from 'src/app/services/rapid-tour/rapidtour.service';
import { Capacitor } from '@capacitor/core';
import { TreasurehuntService } from 'src/app/services/treasureHunt/treasurehunt.service';
import { Geolocation } from '@capacitor/geolocation';
import { PopoverComponent } from 'src/app/components/popover/popover.component';
import { LeaderboardOverallComponent } from 'src/app/components/leaderboard-overall/leaderboard-overall.component';
import { WinnersSplashScreenPage } from '../treasure_hunt/winners-splash-screen/winners-splash-screen.page';
import { ThStoryPage } from '../treasure_hunt/th-story/th-story.page';
import { BaseInjectorService } from '../../base/base-service.injector';
import { environment } from '../../../environments/environment';
import { AppInfoService } from 'src/app/services/app/app-info/app-info.service';
@Component({
  selector: 'app-more',
  templateUrl: './more.page.html',
  styleUrls: ['./more.page.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class MorePage extends BaseInjectorService implements OnInit {

  @Input() isNewVersionAvailable!: boolean;
  
  versionNumber: any;
  menuList: any[] = [];
  pageTitle = this.translate.instant('DASHBOARD.GRAPH.MORE');
  lastUpdatedTime: string;
  // headerHeight = '60px';
  // policyMenu = {
  //   params: {
  //     queryParams: {
  //       fromPage: "PRIVACY_POLICY",
  //       queryParamsHandling: "preserve",
  //       title: "PRIVACY_POLICY_TITLE",
  //       url: "https://bogglobaldocs-prod.web.app/privacyPolicy.html"
  //     }
  //   },
  //   title : "PRIVACY_POLICY_TITLE",
  //   url: "/policy-and-terms"
  // };
  defaultUrl: any = 'dashboard';
  showBackBtn = true;
  isAreaManager: boolean = false;
  show_hse_report: boolean = false;
  // show_hse_report: boolean = true;
  HSE_user_countryName: any = '';
  getProfileImage: any;

  constructor(
    private greenPass: GreenpassService,
    private thService: TreasurehuntService,
    public popoverController: PopoverController,
    private areaService: AreaManagementService,
    private _modal: ModalController,
    public platform: Platform,
    public appService: AppService,
    private route: ActivatedRoute,
    private dataResolver: DataResolverService,
    private rapidtourService: RapidtourService,
    public service: AppService,
    public appInfoService: AppInfoService
  ) {
    super();
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes.isNewVersionAvailable) {
  //     this.isNewVersionAvailable = changes.isNewVersionAvailable.currentValue;
  //     console.log('MorePage ngOnChanges isNewVersionAvailable : ', this.isNewVersionAvailable);
  //   } 
  // }

  async ngOnInit() {
    this.profileImage();
    this.menulist();
    this.checkHSErole();
    // if (this.platform.is('cordova')) {
    if (Capacitor.isNativePlatform()) {
      this.versionNumber = (await App.getInfo()).version;
      // console.log('this.versionNumber',this.versionNumber);
    } else {
      // if (this.platform.is('mobileweb')) {
      this.versionNumber = environment.app_version;
    }

    this.isNewVersionAvailable = await this.appInfoService.getNewUpdateStatus();
   // console.log('MorePage ngOnInit isNewVersionAvailable:', this.isNewVersionAvailable);
  }

  async profileImage() {
    if (this.appService?.connectionState) {
      this.getProfileImage = this.appService.appData.userInfo.profile_image;
    }
    // else if (this.appService?.connectionState && !this.appService?.appData?.userInfo?.profile_image) {
    //  this.getProfileImage="assets/img/menu_icons/icon_profile.png";
    // }
    else if (!this.appService?.connectionState) {
      const localOfflinePic = await this.lhStorage.get('profilePic');
      if (localOfflinePic) {
        this.getProfileImage = localOfflinePic;
      }
    }
    // else{
    //   this.getProfileImage= "assets/img/menu_icons/icon_profile.png";
    // }
  }

  async menulist() {
    let docData: any[] = [];
    // let docInfo = await this.lhFire.collection('pages').ref
    //   .get()
    let docInfo = await this.lhFire.queryCollection('pages');
    docInfo.docs?.forEach((doc: any) => {
      docData.push(doc.data());
    });

  //'meni list', docData);
  }

  async ionViewDidEnter() {
    const lastRefreshed = await this.lhStorage.get('last_refreshed');
    this.lastUpdatedTime = this.moment(lastRefreshed).format('DD-MMM-yyyy, hh:mm A');
  //  console.log('Last Refreshed Time', this.lastUpdatedTime);

    const appData = await this.lhStorage.get('appData');
    this.menuList = appData.menuPages;
    this.menuList.forEach((element) => {
      const str = element.url.split('/');
      element['qk_id'] = str[1];
       if (element.url == '/report-dashboard' && this.appService.appData.userInfo.role=='user') {
          element.active = false;
        }
    });
  //  console.log('menuList=', this.menuList);
    if (
      !(
        this.appService.appData.userInfo.profile == 'Country ExCo' ||
        this.appService.appData.userInfo.icare?.roles == 'HSE Head'
      )
    ) {
      let index = this.menuList.indexOf((x) => x.qk_id == 'all-shield-report');
      if (index > 0) this.menuList.splice(index, 1);
    }
    let zoneOwnerDetails:any={}
    zoneOwnerDetails=await this.areaService.checkUserIsZoneOwner(this.appService.appData.locationMaster.plant);
    let isZoneOwner=false;
    if(Object.keys(zoneOwnerDetails).length>0){
      isZoneOwner=true;
    }
    this.checkIsAreaManagerOrNot(isZoneOwner);
  }
  checkIsAreaManagerOrNot(isZoneOwner) {
    if (this.appService.appData.userInfo.role == 'user' && isZoneOwner) {
      this.menuList.forEach((element) => {
        if (element.url == '/report-dashboard') {
          element.active = true;
        }
      });
    }else{
      this.menuList.forEach((element) => {
        if (element.url == '/report-dashboard') {
          element.active = true;
        }
      });
    }
  }

  async showStoryPagePopup() {
    let showPlayBtn = false;
    const storyModal = await this._modal.create({
      component: ThStoryPage,
      cssClass: '',
      backdropDismiss: true,
      componentProps: {
        showPlayBtn,
      },
    });
    storyModal.onDidDismiss().then(() => { });

    return await storyModal.present();
  }
  async showSplashPopup() {
    this.thService.updateSoryStartStage(false);
    this.showStoryPagePopup();
    const modal = await this._modal.create({
      component: WinnersSplashScreenPage,
      cssClass: 'th-splash',
      backdropDismiss: true,
      componentProps: {},
    });
    modal.onDidDismiss().then(async () => {
      setTimeout(() => {
        this.thService.updateSoryStartStage(true);
      }, 300);
    });
    setTimeout(() => {
      modal.dismiss();
    }, 40000);

    return await modal.present();
  }

  async showLeaderboardScreen() {
    const modal = await this._modal.create({
      component: LeaderboardOverallComponent,
      componentProps: {
        selectedTab: 'BOG Tour',
        closeBtn: true,
      },
      backdropDismiss: true,
    });
    return await modal.present();
  }

  async redirectToSelectedMenu(menu) {
    if (!this.appService.connectionState) return;

    this._modal.dismiss();
    this.logger.info('MENU SELECTED IS :', menu);
    if (
      menu.url == '/overall' ||
      menu.url == '/winnerssplash' ||
      menu.url == '/treasure-hunt-create' ||
      menu.url === '/workgroup-management' ||
      menu.url === '/user-management' ||
      menu.url === '/policy-and-terms'
    ) {
      this.logger.info('INTERNET CONNECTIVITY IS :', this.appService.connectionState);
      if (this.appService.connectionState) {
        if (menu.url == '/overall') {
          this.showLeaderboardScreen();
          return;
        }
        if (menu.url == '/winnerssplash') {
          this.showLeaderboardScreen();
          return;
        } else if (menu.url === '/policy-and-terms') {
          // this.menuCtrl.close();
          let params: any = menu.params;
          if (menu.type === 'privacy-policy') {
            params = {
              queryParams: {
                fromPage: 'PRIVACY_POLICY',
                queryParamsHandling: 'preserve',
                title: 'PRIVACY_POLICY_TITLE',
                // url: "https://bogglobaldocs-prod.web.app/privacyPolicy.html"
                url: 'https://bogglobaldocs.web.app/newPrivacyPolicy.html',
              },
            };
            this.router.navigate([menu.url], params || {});
          } else if (menu.type === 'terms-conditions') {
            const localTermsAndConditions = await this.lhStorage.get('terms_and_conditions');
            params = {
              queryParams: {
                fromPage: 'PRIVACY_POLICY',
                queryParamsHandling: 'preserve',
                title: localTermsAndConditions.title,
                url: localTermsAndConditions.url,
              },
            };
            this.router.navigate([menu.url], params || {});
          }
          return;
        }

        if (
          this.appService.appData.userInfo.role === 'super_user' ||
          this.appService.appData.userInfo.role === 'country_admin'
        ) {
          if (menu.url === '/user-management') {
            this.router.navigate([menu.url], menu.params || {});
          } else {
            this.router.navigate([menu.url], menu.params || {});
          }
        } else if (this.appService.appData.userInfo.role === 'admin') {
          if (menu.url === '/user-management') {
            if (
              !this.appService.appData.userInfo.plants_assigned ||
              this.appService.appData.userInfo.plants_assigned.length == 0
            ) {
              this.router.navigate(['/user-management-by-plants'], menu.params || {});
            } else {
              this.router.navigate(['/user-management'], menu.params || {});
            }
          } else {
            //this.router.navigate([menu.url], menu.params || {});
            //removed menu.params for android device back button navigation
            this.router.navigate([menu.url]);
          }
        }
      } else {
        this.overlayService.presentToast(
          this.createToastOptions(this.translate.instant('INTERNET_CONNECTION_FEATURE'))
        );
      }
    } else if (menu.url === '/refresh-data') {
      this.refreshData();
    } else if (menu.url === '/refresh-master-data') {
      this.refreshMasterData();
      this.lhStorage.remove('lastSelectedSiteOrGRU');
      this.lhStorage.remove('allQR');
      this.lhStorage.remove('new_ppes_array');
      this.lhStorage.remove('new_pues_array');
      //await this.checkIsAreaManagerOrNot();
    } else if (menu.url === '/area-management-screen') {
      this.router.navigate([menu.url], menu.params || {});
    } else if (menu.url === '/all-shield-report') {
      this.router.navigate([menu.url], { queryParams: { country: this.HSE_user_countryName } });
    } else if (menu.url === '/housekeeping-filter') {
      // console.log(menu.url);
      this.router.navigate([menu.url], { replaceUrl: true });
    } else {
      //this.router.navigate([menu.url], menu.params || {});
      //removed menu.params for android device back button navigation
      this.router.navigate([menu.url]);
    }
  }

  async refreshMasterData() {
    const requestMasterData = this.apiService.httpsCallable('extractIcareMasterData');
    this.logger.log('ICARE MASTER DATA IS :', requestMasterData);
  }

  async openAreaManagement(data) {
    if (data == 'area-management-screen') {
      this.router.navigate(['/area-management-screen'], {});
    } else if (data == 'report-dashboard') {
      this.router.navigate(['/report-dashboard'], {});
    }
  }

  async refreshData() {
    this.lhStorage.remove('lastVisitedOpco');
    this._modal.dismiss();
    let versionNumber;
    if (this.appService.connectionState) {
      await this.overlayService.presentLoading(
        this.createLoaderOptions(this.translate.instant('USER_DASHBOARD.REFRESH_APP_DATA_LOADER'))
      );
      let versionNumber = environment.app_version;
      if (Capacitor.isNativePlatform()) {
        versionNumber = (await App.getInfo()).version;
      }
      // if (this.platform.is('cordova')) {
      //   versionNumber = (await App.getInfo()).version;
      // } else if (this.platform.is('mobileweb')) {
      //   versionNumber = environment.app_version;
      // }
      this.dataResolver
        .getAppData({ uid: this.appService.appData.userInfo.email }, versionNumber)
        .then(async (response) => {
          if (
            !this.appService.appData.userInfo ||
            !this.appService.appData.userInfo.region ||
            !this.appService.appData.userInfo.country ||
            !this.appService.appData.userInfo.opco ||
            !this.appService.appData.userInfo.plant ||
            !this.appService.appData.userInfo.department ||
            !this.appService.appData.userInfo.departmentId ||
            !this.appService.appData.userInfo.Fname ||
            !this.appService.appData.userInfo.Lname ||
            !this.appService.appData.userInfo.email ||
            !this.appService.appData.userInfo.h_and_s ||
            !this.appService.appData.userInfo.location_unique_id ||
            !this.appService.appData.userInfo.person_unique_id ||
            !this.appService.appData.userInfo.person_auto_number ||
            !this.appService.appData.userInfo.profile ||
            !this.appService.appData.userInfo.role
          ) {
            await this.overlayService.dismissLoading();
            this.signOut();
            await this.overlayService.presentAlert(
              this.createAlertOptions(this.translate.instant('LOGIN.REGISTER_AGAIN'), 'OK')
            );
          } else {

            this.appService.initAppData(this.route);
            this.appService.getAndSetLanguage();

            // this is used for shield users
            if (this.appService.appData.userInfo.shield_user) {
              await this.getAllSiteList();
            }

            this.ionViewDidEnter();
            await this.overlayService.dismissLoading();

            this.overlayService.presentToast(
              this.createToastOptions(
                this.translate.instant('USER_DASHBOARD.DATA_REFRESHED')
              )
            );

            this.logger.log('APP DATA', this.appService.appData);

            //  await this.appService.getTreasureHuntInfo();
            //  await this.appService.getParameters();
            this.events.publish('update_treasurehunt_dashboard', '');
            this.lhStorage.remove('lastSelectedSiteOrGRU');
            this.lhStorage.remove('allQR');
            this.lhStorage.remove('new_ppes_array');
            this.lhStorage.remove('new_pues_array');
            //await this.checkIsAreaManagerOrNot();
          }

          this.events.publish('update_RapidBtn', '');
          this.events.publish('relaodAreaManagementScreen', '');
        })
        .catch(async (error) => {
          await this.overlayService.dismissLoading();
          this.overlayService.presentToast(
            this.createToastOptions(this.translate.instant('USER_DASHBOARD.DATA_NOT_REFRESHED'))
          );
        });
      const lastRefreshedDate = this.moment().toISOString();
      this.lhStorage.set('last_refreshed', lastRefreshedDate);
      this.lhStorage.set('last_refreshed_server', lastRefreshedDate);
    } else {
      this.overlayService.presentToast(
        this.createToastOptions(this.translate.instant('USER_DASHBOARD.STAY_ONLINE'))
      );
    }
  }

  async logout(fromFunction) {
    let msg = '';
    let buttonArray: any;
    if (fromFunction === 'logout') {
      msg = this.translate.instant('USER_DASHBOARD.LBL_LOGOUT_CONFIRMATION');
      buttonArray = [
        {
          text: this.translate.instant('APP_NO'),
          role: 'cancel',
          handler: (blah) => {
            this.logger.log('Confirm Cancel: blah');
          },
        },
        {
          text: this.translate.instant('APP_YES'),
          handler: () => {
            this.signOut();
          },
        },
      ];
    } else {
      msg = this.translate.instant('USER_DASHBOARD.LBL_NOT_REGISTERED_ICARE');
      buttonArray = [
        {
          text: this.translate.instant('APP_OK'),
          handler: () => {
            this.signOut();
          },
        },
      ];
    }
    const alert = await this.alertController.create({
      header: this.translate.instant('APP_BOG_ALERT'),
      message: msg,
      buttons: buttonArray,
    });

    await alert.present();
  }
  async confirmAlert() {
    const alert = await this.alertController.create({
      cssClass: 'abort-alert',
      header: this.translate.instant('TREASURE_HUNT.DEACTIVATE_TEAM_CONFIRM'),
      message: this.translate.instant('LOGOUT_ALERT.MESSAGE'),
      buttons: [
        {
          text: this.translate.instant('ADD_QR.BTN_CANCEL'),
          role: 'cancel',
          cssClass: 'secondary',
          id: 'cancel-button',
          handler: (blah) => { },
        },
        {
          text: this.translate.instant('APP_OK'),
          id: 'confirm-button',
          handler: () => {
            this.signOut();
          },
        },
      ],
    });

    await alert.present();
  }

  async checkTourRun() {
    let currentTour = await this.lhStorage.get('currentTour');
    if (
      this.rapidtourService.isEmpty(currentTour) ||
      currentTour == '' ||
      currentTour.currentBogTourInfo == undefined
    ) {
      this.signOut();
    } else {
      this._modal.dismiss();
      this.rapidtourService.TourEndConfirmation('');
    }
  }
  async signOut() {
    this._modal.dismiss();
    await this.overlayService.presentLoading(
      this.createLoaderOptions(this.translate.instant('APP_LOADING_LABEL'))
    );
    await this.appService.signout_update();
    this.logger.log('LOGOUT CLICKED');
    await this.firebaseAuth.signOut();
    let onlineOfflineStatus = await this.lhStorage.get('onlineOfflineStatus');

   // console.log('signOut Before clear:', await this.lhStorage.keys());
    await this.lhStorage.clear();
   // console.log('signOut After clear:', await this.lhStorage.keys());

    this.overlayService.dismissLoading();
    this.lhStorage.set('onlineOfflineStatus', onlineOfflineStatus);
    this.router.navigate(['/login'], { replaceUrl: true });
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  }
  async profile_info() {
    this._modal.dismiss();
    this.router.navigate(['/profile-info'], {});
  }
  async dismiss() {
    this._modal.dismiss();
  }
  //   closePopup()
  //   {
  // this.viewCtrl.dismiss();
  //   }
  async checkHSErole() {
    let app_data = this.service.appData;
    // console.log('country:',app_data.locationMaster.country);
    // Field Supervisor pankaj
    if ((app_data?.userInfo?.profile).toLowerCase() == 'country exco') {
      this.HSE_user_countryName = app_data.locationMaster.country;
      this.show_hse_report = true;
    } else if ('country_head_of_hs' in this.service.appData.userInfo.icare.roles) {
      this.HSE_user_countryName =
        this.service.appData.userInfo.icare.roles['country_head_of_hs'].country_data[0].location;
      this.show_hse_report = true;
    } else if ('dwk_country_env_head' in this.service.appData.userInfo.icare.roles) {
      this.HSE_user_countryName =
        this.service.appData.userInfo.icare.roles['dwk_country_env_head'].country_data[0].location;
      this.show_hse_report = true;
    }
  }
  async getAllSiteList() {
    let checkInSiteList = await this.lhStorage.get('get_all_sites_list');
    if (!checkInSiteList) {
      try {
        let position = await this.loadDeviceLatLong();
        //console.log("position=", position);
        if (!position?.latitude || !position?.longitude) {
          console.error('Invalid geolocation data');
          return;
        }
        const fetchPlantData = this.apiService.httpsCallable('getAllPlantData');
        fetchPlantData({
          latitude: position.latitude,
          longitude: position.longitude,
          hse_key: this.appService.appData?.userInfo?.shield_user
        }).subscribe({
          next: async (plantResponse) => {
            if (plantResponse?.plant_list) {
              const updatedPlantSites = this.mapSegmentCategories(plantResponse.plant_list);
              await this.lhStorage.set('get_all_sites_list', updatedPlantSites);
            }
          },
          error: async (err) => {
            console.error('Error fetching plant data', err);
          },
        });
      } catch (error) {
        console.error('Error during site check-in initialization', error);
      }
    }
  }
  private mapSegmentCategories(sites: any[], normalizePlant: boolean = false): any[] {
    return sites.map((site) => {
      const match = this.appService.appData.segmentsMaster.segments.find(
        (seg) => seg.name === site.segment
      );
      if (match) site.segment_category_name = match.category;
      if (normalizePlant) site.plant = site.plant_id;
      return site;
    });
  }
  // REQUIRED AS WE ARE STORING THE GEOLOCATION IN FIREBASE userDataBog COLLECTION
  async loadDeviceLatLong() {
    let geolocationData: any;

    if (this.capacitorPlatform === 'web') {
      try {
        const position = await Geolocation.getCurrentPosition({
          enableHighAccuracy: true,
          timeout: 15000, // 15 seconds timeout
          maximumAge: 10000 // 10 seconds cache
        });
        geolocationData = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
      } catch (error) {
        console.warn('High accuracy location failed, trying low accuracy:', error);
        try {
          const position = await Geolocation.getCurrentPosition({
            enableHighAccuracy: false,
            timeout: 30000, // 30 seconds timeout for low accuracy
            maximumAge: 30000 // 30 seconds cache
          });
          geolocationData = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
        } catch (fallbackError) {
          console.error('Location failed completely:', fallbackError);
          // Use default location as fallback
          geolocationData = {
            latitude: 14.4759979,
            longitude: 75.9251408,
          };
        }
      }
    } else {
      try {
        geolocationData = await this.getCurrentLocation(5000);
        this.logger.log('LATITUDE & LONGITUDE DATA IS: ', geolocationData);
      } catch (error) {
        geolocationData = await this.getCurrentLocation(5000);
        this.logger.error('ERROR FETCHING GEOLOCATION IS: ', error);
      }
    }

    return geolocationData;
  }
}
